import { CanDeactivate } from "@angular/router";
import { RiskIndicatorsComponent } from "./risk-indicators.component";
import { MzModalService } from "ng2-materialize";
import { ConfirmLeaveBacklogUnsyncedComponent } from "../confirm-leave-backlog-unsynced/confirm-leave-backlog-unsynced.component";
import { Observable } from "rxjs/Observable";

export class RiskIndicatorsDeactivateGuard
  implements CanDeactivate<RiskIndicatorsComponent> {
  canDeactivate(target: RiskIndicatorsComponent): Observable<boolean> {
    return target.retrospectiveActive
      ? Observable.of(false)
      : Observable.of(true);
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/risk-indicators/risk-indicators-deactivate.guard.ts